module.exports = __webpack_public_path__ + "img/kg_kg_12.49a250aa.png";